import { ReactNode, useMemo } from 'react'
import { useIntl } from 'react-intl'
import clsx from 'clsx'

import { ColumnVisibility, MatchingPayoutPaymentTicket } from '../../core/_models'
import { convertUTCtoMSK } from '../../../../../utils'
import { AmountCell } from '../common/AmountCell'
import { FileDownloadButton } from '../../../../../components/FileDownloadButton/FileDownloadButton'
import { TruncatedValue } from '../../../../common/TruncatedValue'
import { ClientCell } from '../../../../common/ClientCell'
import { MatchingTicketLink } from '../../../../common/MatchingTicketLink'

interface Props {
  ticket: MatchingPayoutPaymentTicket
  visibility: ColumnVisibility
  actionSlot?: ReactNode
  // Колонка действий присутствует в таблице (даже если для этой строки actionSlot пустой).
  showActionColumn?: boolean
}

const FinishedPayoutPaymentTicketRow = ({ ticket, visibility, actionSlot, showActionColumn }: Props) => {
  const intl = useIntl()

  const [file] = ticket?.files || []

  const isAmountChanged = useMemo(() => {
    return ticket.authorId !== null && ticket.amount !== ticket.approximateAmount
  }, [ticket])

  return (
    <tr key={ticket.merchantTransactionId || ticket.ticketToken}>
      <td className='ps-8'><MatchingTicketLink token={ticket.ticketToken} /></td>
      {visibility.createdDate && <td>{convertUTCtoMSK(ticket.createdAt)}</td>}
      {visibility.completionDate && (
        <td>{ticket.completionDate ? convertUTCtoMSK(ticket.completionDate) : '-'}</td>
      )}
      {visibility.amount && (
        <AmountCell
          amount={ticket?.amount}
          expectedAmount={ticket?.approximateAmount}
          isAmountChanged={isAmountChanged}
        />
      )}
      {visibility.user && (
        <ClientCell externalId={ticket.externalUserId} token={ticket.clientToken} />
      )}
      {visibility.merchantId && (
        <td>
          <TruncatedValue value={ticket.merchantTransactionId} />
        </td>
      )}
      {visibility.merchant && <td>{ticket.merchant}</td>}
      {visibility.status && (
        <td>
          {intl.formatMessage({ id: 'ticket.status.' + ticket.status })}
          {ticket.matchReleased && (
            <span className='badge badge-light text-gray-700 ms-2'>Выдача отменена</span>
          )}
        </td>
      )}
      {visibility.file && (
        <td className='downloadLink text-center'>
          {ticket.files && file?.url ? (
            <FileDownloadButton url={file?.url} id={file?.id} status={file?.status} badgePosition='start' badgeStatus={file?.autoCheckStatus} badgekMessage={file?.autoCheckMessage} />
          ) : (
            '-'
          )}
        </td>
      )}
      {visibility.authorId && (
        <td className='text-center align-middle'>
          <span className={clsx('badge', ticket.authorId !== null && 'bg-warning')}>
            {ticket.authorId ?? '-'}
          </span>
        </td>
      )}
      {(showActionColumn || actionSlot) && (
        <td className='text-end align-middle'>{actionSlot ?? null}</td>
      )}
    </tr>
  )
}

export default FinishedPayoutPaymentTicketRow
